import store from "@/store";
import router from "./index";
import admin from "./moduls/admin";
import forms from "./moduls/forms";
import defaultRoute from "./moduls/defaultRoute";
import oa from "./moduls/oa";
import { checkAppUpdate } from "@/utlis/checkUpdate";

router.beforeEach((to, from, next) => {

    if (to.name === "login" || to.push == "/") {
        localStorage.removeItem("Authorization");
        next()
    } else {

        //(未登录)
        if (!localStorage.getItem("Authorization")) {

            next({
                path: "/login"
            });

        } else {
            //已登录
            if (!store.state.permission.isGetterRouter) {
                ConfigRouter();

                next({
                    path: to.fullPath //因为刚添加完路由所以让如有重新走一遍
                });

            } else {
                // 检查是否有考试弹窗打开，如果有则拦截路由跳转
                if (window.__examDialogComponent && window.__examDialogComponent.dialogVisible && from.path !== to.path) {
                    const examComponent = window.__examDialogComponent;
                    examComponent.handlePageLeaveConfirm()
                        .then(() => {
                            // 用户确认，允许跳转
                            next();
                        })
                        .catch(() => {
                            // 用户取消，阻止跳转
                            next(false);
                        });
                    return; // 等待用户确认
                }
                next();
            }

        }
    }
});

router.afterEach((to, from) => {
    if (to.path !== from.path) {
        checkAppUpdate();
    }
});

export const asyncRouterMap = [
    { type: 'manage', routers: admin }, //后台
    { type: 'formField', routers: forms }, //表单
    { type: 'oa', routers: oa }, //审批
    { type: 'default', routers: defaultRoute } //其他路由
];

const ConfigRouter = () => {
    asyncRouterMap.forEach(item => {
        if (item.type === 'default') {
            item.routers.forEach(item2 => {
                router.addRoute(item2);
            })
        } else {
            item.routers.forEach(item2 => {
                router.addRoute(item.type, item2);
            })
        }
    });
    store.commit("CHANG_GETTER_ROUTER", true);
}
